import React from "react";

function Error({ msg }) {
  return (
    <div>
      <div className="alert alert-danger" role="alert">
        {msg} , Please try again.
        {/* {msg} Something went wrong, please try again. */}
      </div>
    </div>
  );
}

export default Error;
